export default "__VITE_PUBLIC_ASSET__edde0873__"